var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVogoPosArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.286133 6.33105C0.286133 6.20801 0.308919 6.09408 0.354492 5.98926C0.400065 5.88444 0.472982 5.78418 0.573242 5.68848L5.57715 0.793945C5.7321 0.638997 5.9235 0.561523 6.15137 0.561523C6.30632 0.561523 6.44531 0.597982 6.56836 0.670898C6.69141 0.739258 6.78939 0.834961 6.8623 0.958008C6.93978 1.08105 6.97852 1.22005 6.97852 1.375C6.97852 1.59831 6.89193 1.79655 6.71875 1.96973L2.24121 6.33105L6.71875 10.6924C6.89193 10.8656 6.97852 11.0638 6.97852 11.2871C6.97852 11.4375 6.93978 11.5742 6.8623 11.6973C6.78939 11.8249 6.69141 11.9251 6.56836 11.998C6.44531 12.071 6.30632 12.1074 6.15137 12.1074C5.9235 12.1074 5.7321 12.0299 5.57715 11.875L0.573242 6.97363C0.472982 6.87793 0.400065 6.77767 0.354492 6.67285C0.308919 6.56803 0.286133 6.4541 0.286133 6.33105Z",
    fill: "#4A5561"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVogoPosArrowPrev);
export default __webpack_public_path__ + "static/media/ic_vogo_pos_arrow_prev.aedfb63c64f26fcfde6ac00f505e24e3.svg";
export { ForwardRef as ReactComponent };